import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Region } from '../region.model';
import { RegionService } from '../region.service';
import { LoaderService } from '../../../shared/services/loader.service';
import { finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RegionsResolver implements Resolve<Region[]> {

  constructor(
    private loader: LoaderService,
    private regionService: RegionService,
  ) {
  }

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Region[]> {
    this.loader.startLoad(false);
    return this.regionService.getAllLight()
      .pipe(finalize(() => this.loader.stopLoad()));
  }
}
